export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74')
];

export const server_loads = [];

export const dictionary = {
		"/": [27],
		"/account": [32,[3]],
		"/account/verify-email": [33,[3]],
		"/admin": [34,[4]],
		"/admin/blacklist-hits": [52,[4,11]],
		"/admin/invites": [53,[4,12]],
		"/admin/jobs": [54,[4,13]],
		"/admin/settings": [55,[4,14]],
		"/admin/speakers": [56,[4,15]],
		"/admin/speakers/new": [59,[4,15]],
		"/admin/speakers/[speaker_tag]": [57,[4,15,16]],
		"/admin/speakers/[speaker_tag]/edit": [58,[4,15,16]],
		"/admin/stats": [60,[4,17]],
		"/admin/stats/[stream_tag]": [61,[4,17]],
		"/admin/streams": [62,[4,18]],
		"/admin/streams/new": [66,[4,18]],
		"/admin/streams/[stream_tag]": [63,[4,18,19]],
		"/admin/streams/[stream_tag]/edit": [64,[4,18,19]],
		"/admin/streams/[stream_tag]/refresh": [65,[4,18,19]],
		"/admin/[tag]": [35,[4,5]],
		"/admin/[tag]/moderation": [36,[4,5,6]],
		"/admin/[tag]/overlay": [37,[7]],
		"/admin/[tag]/panel": [38,[4,5,8]],
		"/admin/[tag]/settings": [39,[4,5,9]],
		"/admin/[tag]/settings/broadcast": [40,[4,5,9]],
		"/admin/[tag]/settings/goals": [41,[4,5,9]],
		"/admin/[tag]/settings/image-tips": [42,[4,5,9]],
		"/admin/[tag]/settings/overlay": [43,[4,5,9]],
		"/admin/[tag]/settings/overlay/[short_id]": [44,[4,5,9]],
		"/admin/[tag]/settings/payments": [45,[4,5,9]],
		"/admin/[tag]/settings/show": [46,[4,5,9]],
		"/admin/[tag]/settings/text-tips": [47,[4,5,9]],
		"/admin/[tag]/settings/voice-tips": [48,[4,5,9]],
		"/admin/[tag]/verify-email": [49,[4,5]],
		"/admin/[tag]/voices/new": [51,[4,5,10]],
		"/admin/[tag]/voices/[voice_tag]": [50,[4,5,10]],
		"/diagnostics": [67],
		"/leaderboard": [68,[20]],
		"/onboard": [70,[22]],
		"/o/[short_id]": [69,[21]],
		"/privacy": [71,[23]],
		"/signin": [72,[24]],
		"/submission": [73,[25]],
		"/terms": [74,[26]],
		"/[tag]": [28,[2]],
		"/[tag]/image": [29,[2]],
		"/[tag]/text": [30,[2]],
		"/[tag]/voice": [31,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';